import { getDistinctValues } from "./utilFunctions";
import { toOptionsList } from "./utilFunctions";

const getLocOptions = (obj, selectedYears) => {
    const locs = [];
    for (const year of selectedYears) {
        if (obj.hasOwnProperty(year))
            locs.push(...Object.keys(obj[year]))
    }
    return getDistinctValues(locs);
}

const getLineOptions = (obj, selectedYears, selectedLocs) => {
    const lines = [];
    for (const year of selectedYears) {
        const locsList = selectedLocs.length > 0 ? selectedLocs :
            obj.hasOwnProperty(year) ? Object.keys(obj[year]) : []
        for (const loc of locsList) {
            if (obj[year].hasOwnProperty(loc)) {
                if (obj[year][loc].hasOwnProperty('Lines')) {
                    lines.push(...Object.keys(obj[year][loc]['Lines']))
                }
            }
        }
    }
    return getDistinctValues(lines);
}

const getExptOptions = (obj, selectedYears, selectedLocs, selectedLines = []) => {
    const expts = [];
    for (const year of selectedYears) {
        const locsList = selectedLocs.length > 0 ? selectedLocs : obj.hasOwnProperty(year) ? Object.keys(obj[year]) : []
        for (const loc of locsList) {
            if (obj[year].hasOwnProperty(loc)) {
                if (selectedLines.length > 0) {
                    for (const line of selectedLines) {
                        if (obj[year][loc]['Lines'].hasOwnProperty(line)) {
                            expts.push(...obj[year][loc]['Lines'][line]);
                        }
                    }
                }
                else {
                    if (obj[year][loc].hasOwnProperty('Expts')) {
                        expts.push(...Object.keys(obj[year][loc]['Expts']))
                    }
                }
            }
        }
    }
    return getDistinctValues(expts);

}

const getTraitOptions = (obj, selectedExpts) => {
    const traits = [];
    for (const year of Object.keys(obj)) {
        for (const loc of Object.keys(obj[year])) {
            const exptsList = selectedExpts.length > 0 ? selectedExpts :
                obj[year][loc].hasOwnProperty('Expts') ? Object.keys(obj[year][loc]['Expts']) : [];
            for (const expt of exptsList) {
                if (obj[year][loc]['Expts'].hasOwnProperty(expt)) {
                    traits.push(...obj[year][loc]['Expts'][expt])
                }
            }

        }
    }
    return getDistinctValues(traits);
}

const getLineOptionsExptData = (obj, selectedYears) => {
    const lines = [];
    for (const year of selectedYears) {
        if (obj.hasOwnProperty(year))
            lines.push(...obj[year])
    }
    return getDistinctValues(lines);
}

const getValidSelectedOptions = (valid, selected) => {
    return selected.filter(option => valid.includes(option));
}


const getFilteredOptions = (dataType, filterObject, selectedTab, selectedOptions) => {
    if (dataType === 'raw' || dataType === 'means') {
        return filterOptionsForRawMeansBlups(filterObject, selectedTab, selectedOptions, false);
    }
    if (dataType === 'blups') {
        return filterOptionsForRawMeansBlups(filterObject, selectedTab, selectedOptions, true);
    }
    if (dataType === 'expt') {
        return filterOptionsForExpt(filterObject, selectedTab, selectedOptions);
    }
    if (dataType === 'rawLines' || 'meansLines') {
        return filterOptionsForRawMeansSelectedLines(filterObject, selectedTab, selectedOptions)
    }

}

const filterOptionsForRawMeansBlups = (filterObject, selectedTab, selectedOptions, isBlups) => {
    const years = selectedOptions.Years.length > 0 ? selectedOptions.Years : Object.keys(filterObject);
    const modifiedSelectedOptions = {};
    const modifiedOptions = {};
    if(selectedTab === 'Years') {
        modifiedOptions.Years = toOptionsList(Object.keys(filterObject));
    }
    if (selectedTab === 'Locations' || selectedTab === 'Experiments' || selectedTab === 'Traits'|| selectedTab === 'ALL') {
        const locs = getLocOptions(filterObject, years);
        modifiedSelectedOptions.Locations = getValidSelectedOptions(locs, selectedOptions.Locations);
        modifiedOptions.Locations = toOptionsList(locs)
    }
    if (selectedTab === 'Experiments' || selectedTab === 'Traits' || selectedTab === 'ALL') {
        const expts = getExptOptions(filterObject, years, modifiedSelectedOptions.Locations);
        modifiedSelectedOptions.Experiments = getValidSelectedOptions(expts, selectedOptions.Experiments);
        modifiedOptions.Experiments = toOptionsList(expts);

    }
    if (selectedTab === 'Traits' || selectedTab === 'ALL') {
        const traits = getTraitOptions(filterObject, modifiedSelectedOptions.Experiments);
        if (isBlups) {
            const blups_invalid_traits_regex = new RegExp('.+_WT$|^W_.+')
            const validTraits = traits.filter(trait => !blups_invalid_traits_regex.test(trait));
            modifiedSelectedOptions.Traits = getValidSelectedOptions(validTraits, selectedOptions.Traits);
            modifiedOptions.Traits = toOptionsList(validTraits);
        }
        else {
            modifiedSelectedOptions.Traits = getValidSelectedOptions(traits, selectedOptions.Traits);
            modifiedOptions.Traits = toOptionsList(traits);
        }
    }
    return { modifiedOptions, modifiedSelectedOptions }
}



const filterOptionsForRawMeansSelectedLines = (filterObject, selectedTab, selectedOptions) => {
    const years = selectedOptions.Years.length > 0 ? selectedOptions.Years : Object.keys(filterObject);
    const modifiedSelectedOptions = {};
    const modifiedOptions = {};
    if(selectedTab === 'Years') {
        modifiedOptions.Years = toOptionsList(Object.keys(filterObject))
    }
    if (selectedTab === 'Locations' || selectedTab === 'Lines' ||
        selectedTab === 'Experiments' || selectedTab === 'Traits' || selectedTab === 'ALL') {
        const locs = getLocOptions(filterObject, years);
        modifiedSelectedOptions.Locations = getValidSelectedOptions(locs, selectedOptions.Locations);
        modifiedOptions.Locations = toOptionsList(locs)
    }
    if (selectedTab === 'Lines' || selectedTab === 'Experiments' || selectedTab === 'Traits' || selectedTab === 'ALL') {
        const lines = getLineOptions(filterObject, years, modifiedSelectedOptions.Locations);
        modifiedSelectedOptions.Lines = getValidSelectedOptions(lines, selectedOptions.Lines);
        modifiedOptions.Lines = toOptionsList(lines);
    }
    if (selectedTab === 'Experiments' || selectedTab === 'Traits' || selectedTab === 'ALL') {
        const expts = getExptOptions(filterObject, years,
            modifiedSelectedOptions.Locations, modifiedSelectedOptions.Lines);
        modifiedSelectedOptions.Experiments = getValidSelectedOptions(expts, selectedOptions.Experiments);
        modifiedOptions.Experiments = toOptionsList(expts);
    }
    if (selectedTab === 'Traits' || selectedTab === 'ALL') {
        const traits = getTraitOptions(filterObject, modifiedSelectedOptions.Experiments);
        modifiedSelectedOptions.Traits = getValidSelectedOptions(traits, selectedOptions.Traits);
        modifiedOptions.Traits = toOptionsList(traits);
    }
    return { modifiedOptions, modifiedSelectedOptions }
}

const filterOptionsForExpt = (filterObject, selectedTab, selectedOptions) => {
    const years = selectedOptions.Years.length > 0 ? selectedOptions.Years : Object.keys(filterObject);
    const modifiedSelectedOptions = {};
    const modifiedOptions = {};
    if(selectedTab === 'Years' || selectedTab === 'ALL') {
        modifiedOptions.Years = toOptionsList(Object.keys(filterObject))
    }
    if (selectedTab === 'Lines' || selectedTab === 'ALL') {
        const lines = getLineOptionsExptData(filterObject, years);
        modifiedSelectedOptions.Lines = getValidSelectedOptions(lines, selectedOptions.Lines);
        modifiedOptions.Lines = toOptionsList(lines)
    }
    return { modifiedOptions, modifiedSelectedOptions }
}



export { getFilteredOptions }